
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface TaskPriorityUrgencyProps {
  priority: 'high' | 'medium' | 'not-important' | null;
  onPriorityChange: (value: string) => void;
}

const TaskPriorityUrgency: React.FC<TaskPriorityUrgencyProps> = ({
  priority,
  onPriorityChange
}) => {
  return (
    <div className="space-y-1">
      <Label htmlFor="priority">Priority</Label>
      <Select value={priority || 'none'} onValueChange={onPriorityChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select priority" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="high">Urgent</SelectItem>
          <SelectItem value="medium">Normal</SelectItem>
          <SelectItem value="not-important">Low</SelectItem>
          <SelectItem value="none">None</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default TaskPriorityUrgency;
